<template>
    <div
        v-bind="attrs"
        class="relative text-center"
        @mouseenter="hoverActive = true"
        @mouseleave="hoverActive = false"
    >
        <edit-toggle-button
            v-show="portalContentAndDesignStore.liveDesignerEnabled && (isEditing || hoverActive)"
            :isEditing="isEditing"
            @toggle="toggleEdit"
            class="transition-opacity duration-200"
        />

        <!-- Normal Display Mode -->
        <social-auth-btn
            v-if="!isEditing"
            provider="google"
            :submit-url="socialSubmitUrl"
            :text="model"
        ></social-auth-btn>

        <!-- Editable Input Mode -->
        <input
            v-else
            v-bind="attrs"
            v-model="model"
            class="focus:ring-black text-center"
            :class="portalContentAndDesignStore.getInputStyle"
        />
    </div>
</template>

<script setup>
import {usePortalContentAndDesignStore} from "../../../stores/partners/portalContentAndDesignStore";
import {computed, ref, useAttrs} from "vue";
import EditToggleButton from "../Pub/components/EditToggleButton.vue";


    const props = defineProps({
        socialProvider: {
            type: String,
            required: true
        },
        socialSubmitUrl: {
            type: String,
            required: true
        },
        modelValue: {
            type: String,
            required: true
        },
    });

    const isEditing = ref(false);
    const hoverActive = ref(false);
    const attrs = useAttrs();

    const toggleEdit = () => {
        isEditing.value = !isEditing.value
        if (!isEditing.value) {
            hoverActive.value = false
        }
    }

    const portalContentAndDesignStore = usePortalContentAndDesignStore();

    const emit = defineEmits(['update:modelValue']);

    const model = computed({
        get: () => props.modelValue,
        set: (val) => emit('update:modelValue', val)
    });
</script>
